export type FeedSource = 'pt' | 'group' | 'newOpportunity';

export const getFeedSource = (feed: any): FeedSource => {
    const source = feed?.source || feed?.scheduleReport?.scheduleInfo?.source;

    if (source === 'newOpportunity' || feed?.newOpportunityId) {
        return 'newOpportunity';
    }

    if (source === 'group' || feed?.postType === 'GROUP_SESSION_LOG') {
        return 'group';
    }

    return 'pt';
};

export const isScheduleFeed = (feed: any) =>
    feed?.postType === 'SCHEDULEREPORT' || feed?.postType === 'GROUP_SESSION_LOG';

export const getFeedBadge = (feed: any) => {
    if (!isScheduleFeed(feed)) {
        return { label: '게시물', color: '#6B7280', background: '#F3F4F6' };
    }

    const source = getFeedSource(feed);
    if (source === 'newOpportunity') {
        const title = feed?.scheduleReport?.scheduleInfo?.sessionTitle || '수업';
        return { label: `${title} 일지`, color: '#7C3AED', background: '#F5F3FF' };
    }
    if (source === 'group') {
        return { label: '그룹 수업일지', color: '#059669', background: '#ECFDF5' };
    }
    return { label: 'PT 수업일지', color: '#2563EB', background: '#EFF6FF' };
};

export const getFeedScheduleTitle = (feed: any) => {
    const info = feed?.scheduleReport?.scheduleInfo;
    const source = getFeedSource(feed);

    if (source === 'newOpportunity') return info?.sessionTitle || '수업';
    if (source === 'group') return info?.sessionTitle || info?.ticketName || '그룹 수업';
    return info?.membershipName || 'PT 수업';
};

// ── 피드 필터 ──────────────────────────────────────────────────────────────
// 관리자 피드의 정렬 드롭다운에는 성격이 다른 두 종류의 필터가 한 목록에 섞여 있다.
//   · 게시물 종류로 거르는 값(postType 파라미터)  — 수업 일지, 공지글
//   · 작성자 역할로 거르는 값(writerRole 파라미터) — 강사 게시글, 회원 게시글
// 어느 쪽 파라미터로 보낼지 여기서 한 곳에 모아 판단한다. 값을 엉뚱한 파라미터로 보내면
// 서버는 조용히 'all' 로 처리해 필터가 걸리지 않은 것처럼 보인다.
export const FEED_POST_TYPE_FILTERS = ['SCHEDULEREPORT', 'FIXED'];
export const FEED_WRITER_ROLE_FILTERS = ['coach', 'member'];

export const resolveFeedPostTypeParam = (sortValue: string) =>
    FEED_POST_TYPE_FILTERS.includes(sortValue) ? sortValue : 'all';

export const resolveFeedWriterRoleParam = (sortValue: string) =>
    FEED_WRITER_ROLE_FILTERS.includes(sortValue) ? sortValue : 'all';
